import { createStyles } from '@mui/styles'

const styles = createStyles({
  avatar: {
    marginRight: 0,
    width: 35,
    height: 35,
  },
})

export default styles
